<debug-session-banner>
    <!-- Debug banner overlay - draggable on left side -->
    <div class="debug-banner-wrapper" 
         if="{state.isDebugMode}"
         style="left: {state.position.x}px; top: {state.position.y}px;">
        <div class="debug-banner">
            <div class="debug-content">
                <div class="debug-header" onmousedown="{startDrag}">
                    <i class="icon-metalark-bug"></i>
                    <span class="debug-title">{locale?.t('admin_debug_session_info')}</span>
                    <button class="close-btn" onclick="{closeDebugBanner}" aria-label="{locale?.t('close')}">
                        <i class="icon-metalark-x"></i>
                    </button>
                </div>

                <div class="debug-grid">
                    <div class="debug-item">
                        <span class="label">{locale?.t('admin_debug_session_countdown')}:</span>
                        <span class="value countdown">{state.debugInfo.countdownFormatted}</span>
                    </div>

                    <div class="debug-item">
                        <span class="label">{locale?.t('admin_debug_expires_at')}:</span>
                        <span class="value">{formatExpiresAt(state.debugInfo.sessionStatus)}</span>
                    </div>

                    <div class="debug-item">
                        <span class="label">{locale?.t('admin_debug_last_activity')}:</span>
                        <span class="value">{state.debugInfo.lastActivityTimeFormatted}</span>
                    </div>

                    <div class="debug-item">
                        <span class="label">{locale?.t('admin_debug_idle_time')}:</span>
                        <span class="value idle">{state.debugInfo.idleTimeFormatted}</span>
                    </div>

                    <div class="debug-item">
                        <span class="label">{locale?.t('admin_debug_session_status')}:</span>
                        <span class="value status" class="status-{getStatusClass(state.debugInfo.sessionStatus)}">
                            {getStatusText(state.debugInfo.sessionStatus)}
                        </span>
                    </div>

                    <div class="debug-item" if="{state.debugInfo.sessionStatus.initialized}">
                        <span class="label">{locale?.t('admin_debug_minutes_remaining')}:</span>
                        <span class="value">{state.debugInfo.sessionStatus.minutesRemaining}</span>
                    </div>

                    <div class="debug-item">
                        <span class="label">{locale?.t('admin_debug_auto_renewals')}:</span>
                        <span class="value">{state.debugInfo.renewalCount || 0}</span>
                    </div>

                    <div class="debug-item">
                        <span class="label">{locale?.t('admin_debug_session_duration')}:</span>
                        <span class="value">{getConfigValue(state.debugInfo.config, 'sessionDurationMinutes')} {locale?.t('min')}</span>
                    </div>

                    <div class="debug-item">
                        <span class="label">{locale?.t('admin_debug_renew_before_expiry')}:</span>
                        <span class="value">{getConfigValue(state.debugInfo.config, 'renewBeforeExpiryMinutes')} {locale?.t('min')}</span>
                    </div>

                    <div class="debug-item">
                        <span class="label">{locale?.t('admin_debug_check_interval')}:</span>
                        <span class="value">{formatInterval(state.debugInfo.config?.checkIntervalMs)}</span>
                    </div>
                </div>

                <div class="debug-actions">
                    <button class="action-btn primary" onclick="{renewSession}">
                        <i class="icon-metalark-sync"></i>
                        <span>{locale?.t('admin_debug_renew_session')}</span>
                    </button>
                    <button class="action-btn warning" onclick="{accelerateExpiration}">
                        <i class="icon-metalark-clock"></i>
                        <span>{locale?.t('admin_debug_accelerate_to_end')}</span>
                    </button>
                    <button class="action-btn warning" onclick="{accelerateExpiration15s}">
                        <i class="icon-metalark-clock"></i>
                        <span>{locale?.t('admin_debug_15s')}</span>
                    </button>
                </div>
            </div>
        </div>
    </div>

    <style>
        debug-session-banner {
            display: block;
        }

        .debug-banner-wrapper {
            position: fixed;
            z-index: 2000;
            max-width: 90vw;
            max-height: 90vh;
            overflow: auto;
            user-select: none;
        }

        .debug-banner-wrapper.dragging {
            user-select: none;
        }

        .debug-banner {
            background: linear-gradient(135deg, #1e293b 0%, #0f172a 100%);
            color: #e2e8f0;
            border: 2px solid #475569;
            border-radius: 12px;
            box-shadow: 0 20px 25px rgba(0, 0, 0, 0.5), 0 0 0 1px rgba(71, 85, 105, 0.3);
            padding: 20px;
            min-width: 400px;
            font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;
            font-size: 13px;
        }

        .debug-content {
            display: flex;
            flex-direction: column;
            gap: 16px;
        }

        .debug-header {
            display: flex;
            align-items: center;
            justify-content: space-between;
            gap: 12px;
            padding-bottom: 12px;
            border-bottom: 1px solid #334155;
            cursor: grab;
            user-select: none;
        }

        .debug-header:active {
            cursor: grabbing;
        }

        .debug-header i {
            font-size: 18px;
            color: #60a5fa;
        }

        .debug-title {
            font-weight: 600;
            font-size: 14px;
            color: #60a5fa;
            flex: 1;
        }

        .close-btn {
            background: transparent;
            border: none;
            color: #94a3b8;
            cursor: pointer;
            padding: 4px 8px;
            border-radius: 4px;
            transition: all 0.2s;
            display: flex;
            align-items: center;
            justify-content: center;
            user-select: none;
            flex-shrink: 0;
        }

        .close-btn:hover {
            background: rgba(148, 163, 184, 0.1);
            color: #cbd5e1;
        }

        .close-btn:active {
            background: rgba(148, 163, 184, 0.2);
        }

        .debug-grid {
            display: grid;
            grid-template-columns: 1fr 1fr;
            gap: 12px;
        }

        .debug-item {
            display: flex;
            flex-direction: column;
            gap: 4px;
            padding: 8px;
            background: rgba(15, 23, 42, 0.5);
            border-radius: 6px;
            border: 1px solid #334155;
        }

        .label {
            color: #94a3b8;
            font-size: 11px;
            text-transform: uppercase;
            letter-spacing: 0.5px;
        }

        .value {
            color: #e2e8f0;
            font-weight: 600;
            font-size: 13px;
        }

        .value.countdown {
            color: #fbbf24;
            font-size: 16px;
        }

        .value.idle {
            color: #86efac;
        }

        .value.status {
            display: inline-block;
            padding: 2px 6px;
            border-radius: 3px;
            font-size: 12px;
        }

        .value.status-active {
            background: rgba(34, 197, 94, 0.2);
            color: #86efac;
        }

        .value.status-expiring {
            background: rgba(251, 191, 36, 0.2);
            color: #fbbf24;
        }

        .value.status-expired {
            background: rgba(239, 68, 68, 0.2);
            color: #fca5a5;
        }

        .value.status-unknown {
            background: rgba(148, 163, 184, 0.2);
            color: #cbd5e1;
        }

        .debug-actions {
            display: flex;
            gap: 8px;
            padding-top: 12px;
            border-top: 1px solid #334155;
        }

        .action-btn {
            flex: 1;
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 6px;
            padding: 8px 12px;
            border: 1px solid transparent;
            border-radius: 6px;
            font-size: 12px;
            font-weight: 600;
            cursor: pointer;
            transition: all 0.2s;
            font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;
        }

        .action-btn i {
            font-size: 14px;
        }

        .action-btn.primary {
            background: rgba(96, 165, 250, 0.15);
            border-color: #60a5fa;
            color: #60a5fa;
        }

        .action-btn.primary:hover {
            background: rgba(96, 165, 250, 0.25);
            border-color: #93c5fd;
            color: #93c5fd;
        }

        .action-btn.primary:active {
            background: rgba(96, 165, 250, 0.35);
        }

        .action-btn.warning {
            background: rgba(251, 191, 36, 0.15);
            border-color: #fbbf24;
            color: #fbbf24;
        }

        .action-btn.warning:hover {
            background: rgba(251, 191, 36, 0.25);
            border-color: #fde047;
            color: #fde047;
        }

        .action-btn.warning:active {
            background: rgba(251, 191, 36, 0.35);
        }

        @media (max-width: 600px) {
            .debug-banner {
                min-width: auto;
                width: calc(100vw - 40px);
            }

            .debug-grid {
                grid-template-columns: 1fr;
            }

            .debug-actions {
                flex-direction: column;
            }
        }
    </style>

    <script>
        import { getDebugSessionService } from '../../services/service-loader';

        export default {
            includeTools: false,
            includeStore: true,

            state: {
                isDebugMode: false,
                position: {
                    x: 20,
                    y: 100
                },
                debugInfo: {
                    sessionStatus: {},
                    lastActivityTime: null,
                    lastActivityTimeFormatted: null,
                    idleTimeMs: 0,
                    idleTimeFormatted: '00:00',
                    countdownFormatted: 'N/A'
                }
            },

            async onMounted() {
                console.log('[Debug Banner] Mounted')

                // Load debug session service
                this.debugSessionService = await getDebugSessionService()

                // Initialize drag state
                this.isDragging = false
                this.dragStart = { x: 0, y: 0 }
                this.dragOffset = { x: 0, y: 0 }
                this.dragEndListener = null
                this.dragMoveListener = null

                // Subscribe to debug mode changes
                this.unsubscribeDebugMode = this.debugSessionService.on('debug-mode-changed', (data) => {
                    console.log('[Debug Banner] Debug mode changed:', data.enabled)
                    this.update({ isDebugMode: data.enabled })
                    // Set position when debug mode is enabled
                    if (data.enabled) {
                        setTimeout(() => {
                            this.update({
                                position: { x: 20, y: Math.max(100, window.innerHeight / 2 - 150) }
                            })
                        }, 0)
                    }
                })

                // Subscribe to debug info updates
                this.unsubscribeDebugInfo = this.debugSessionService.on('debug-info-updated', (debugInfo) => {
                    this.update({ debugInfo })
                })
            },

            onUnmounted() {
                console.log('[Debug Banner] Unmounted')
                if (this.unsubscribeDebugMode) {
                    this.unsubscribeDebugMode()
                }
                if (this.unsubscribeDebugInfo) {
                    this.unsubscribeDebugInfo()
                }
                // Clean up drag listeners
                if (this.dragEndListener) {
                    document.removeEventListener('mouseup', this.dragEndListener)
                }
                if (this.dragMoveListener) {
                    document.removeEventListener('mousemove', this.dragMoveListener)
                }
            },

            startDrag(e) {
                // Don't start drag if clicking on close button or action buttons
                if (e.target.closest('.close-btn') || e.target.closest('.action-btn')) {
                    return
                }

                // Prevent default to avoid text selection
                e.preventDefault()

                console.log('[Debug Banner] Starting drag from:', e.clientX, e.clientY)

                this.isDragging = true
                this.dragStart = { x: e.clientX, y: e.clientY }
                this.dragOffset = { ...this.state.position }

                // Add visual feedback to wrapper
                const wrapper = this.$el?.querySelector('.debug-banner-wrapper')
                if (wrapper) {
                    wrapper.classList.add('dragging')
                }

                // Setup move listener
                this.dragMoveListener = (moveEvent) => {
                    if (!this.isDragging) return

                    const deltaX = moveEvent.clientX - this.dragStart.x
                    const deltaY = moveEvent.clientY - this.dragStart.y

                    const newX = this.dragOffset.x + deltaX
                    const newY = this.dragOffset.y + deltaY

                    // Clamp to screen bounds with some padding
                    const maxX = window.innerWidth - 420 // Account for banner width
                    const maxY = window.innerHeight - 100

                    const clampedX = Math.max(0, Math.min(newX, maxX))
                    const clampedY = Math.max(0, Math.min(newY, maxY))

                    this.update({
                        position: { x: clampedX, y: clampedY }
                    })
                }

                // Setup end listener
                this.dragEndListener = () => {
                    this.isDragging = false
                    const wrapper = this.$el?.querySelector('.debug-banner-wrapper')
                    if (wrapper) {
                        wrapper.classList.remove('dragging')
                    }
                    document.removeEventListener('mousemove', this.dragMoveListener)
                }

                document.addEventListener('mousemove', this.dragMoveListener)
                document.addEventListener('mouseup', this.dragEndListener, { once: true })
            },

            closeDebugBanner() {
                this.debugSessionService.disableDebugMode()
            },

            formatExpiresAt(sessionStatus) {
                if (!sessionStatus.expiresAt) {
                    return this.locale?.t('na') || 'N/A'
                }
                const expiresDate = new Date(sessionStatus.expiresAt)
                const today = new Date()

                // Check if expiration is on a different day
                const isSameDay = expiresDate.toDateString() === today.toDateString()

                if (isSameDay) {
                    // Same day - just show time
                    return expiresDate.toLocaleTimeString()
                } else {
                    // Different day - show date and time
                    return expiresDate.toLocaleDateString() + ' ' + expiresDate.toLocaleTimeString()
                }
            },

            getStatusClass(sessionStatus) {
                if (!sessionStatus.initialized) {
                    return 'unknown'
                }
                if (sessionStatus.expired) {
                    return 'expired'
                }
                if (sessionStatus.inRenewalWindow) {
                    return 'expiring'
                }
                return 'active'
            },

            getStatusText(sessionStatus) {
                if (!sessionStatus.initialized) {
                    return this.locale?.t('admin_debug_status_notinitialized') || 'Not Initialized'
                }
                if (sessionStatus.expired) {
                    return this.locale?.t('admin_debug_status_expired') || 'Expired'
                }
                if (sessionStatus.inRenewalWindow) {
                    return this.locale?.t('admin_debug_status_expiringsoon') || 'Expiring Soon'
                }
                return this.locale?.t('active') || 'Active'
            },

            /**
             * Format milliseconds into readable interval format (e.g., "1m 0s")
             * This is used for displaying the renewal check frequency - how often
             * the session renewal service checks if a session is in the renewal window.
             *
             * The service:
             * 1. Checks immediately on startup
             * 2. Aligns subsequent checks to predictable time boundaries (e.g., :00 and :30 seconds)
             * 3. Repeats at the configured interval (default 30 seconds per tier)
             *
             * This alignment ensures checks happen at predictable times regardless of
             * when the session was initialized, improving reliability near expiration.
             */
            formatInterval(ms) {
                if (!ms) return this.locale?.t('na') || 'N/A'
                const seconds = Math.floor(ms / 1000)
                const minutes = Math.floor(seconds / 60)
                if (minutes > 0) {
                    return `${minutes}m ${seconds % 60}s`
                }
                return `${seconds}s`
            },

            getConfigValue(config, field) {
                if (!config) {
                    console.warn(`[Debug Banner] Config is undefined, using default for ${field}`)
                    return this.locale?.t('na') || 'N/A'
                }
                const value = config[field]
                if (value === undefined || value === null) {
                    console.warn(`[Debug Banner] Config field "${field}" is undefined, value:`, value)
                    return this.locale?.t('na') || 'N/A'
                }
                return value
            },

            async renewSession() {
                console.log('[Debug Banner] Renew session clicked')
                try {
                    await this.debugSessionService.renewSession()
                    console.log('[Debug Banner] Session renewed successfully')
                } catch (error) {
                    console.error('[Debug Banner] Failed to renew session:', error)
                }
            },

            async accelerateExpiration() {
                console.log('[Debug Banner] Accelerate expiration clicked')
                try {
                    await this.debugSessionService.accelerateExpiration()
                    console.log('[Debug Banner] Session accelerated successfully')
                } catch (error) {
                    console.error('[Debug Banner] Failed to accelerate session:', error)
                }
            },

            async accelerateExpiration15s() {
                console.log('[Debug Banner] Accelerate expiration 15s clicked')
                try {
                    await this.debugSessionService.accelerateExpiration(0.25)
                    console.log('[Debug Banner] Session accelerated successfully')
                } catch (error) {
                    console.error('[Debug Banner] Failed to accelerate session:', error)
                }
            }
        }
    </script>
</debug-session-banner>